module.exports = __webpack_public_path__ + "static/media/office-365.0de75840.jpg";